import { Component, Input } from '@angular/core';
import { IProduct2, Product2, Company, WorkflowStateType } from 'situview-webapi-client';
import { AuthService, StateService, ProductService } from 'src/app/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WorkflowTriggerDialogComponent, WorkflowTriggerResultData } from 'src/app/components';
import { INewProduct } from 'src/app/views';

@Component({
  selector: 'product-details-top-bar',
  templateUrl: './product-details-top-bar.component.html',
  styleUrls: ['./product-details-top-bar.component.scss']
})

export class ProductDetailsTopBarComponent extends SituBaseComponent {
  @Input() product: INewProduct = new Product2();
  @Input() productCompany: Company | undefined;
  @Input() isAddMode: boolean = false;
  @Input() isAuthorizedForProductsCompany: boolean = false;

  workflowStateType = WorkflowStateType;
  
  workflowTriggerDialogRef: MatDialogRef<WorkflowTriggerDialogComponent> | undefined;

  constructor(
    authService: AuthService,
    stateService: StateService,
    private snackBar: MatSnackBar,
    private productService: ProductService,
    private dialog: MatDialog) {
    super(authService, stateService);

  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onOpenWorkflowDialog() {
    const dialogWidth = '800px';
    const dialogHeight = '400px';

    this.workflowTriggerDialogRef = this.dialog.open(WorkflowTriggerDialogComponent, {
      width: dialogWidth,
      height: dialogHeight,
      data: {
        workflowSubject: this.product,
        workflowState: this.product.currentWorkflowState,
      }
    });

    this._subscriptions.push(this.workflowTriggerDialogRef.afterClosed()
      .subscribe((data: WorkflowTriggerResultData) => {
        if (!data) {
          // Dialog was closed without triggering workflow
          return;
        }

        this.productService.TriggerProductWorkflow(this.product.companyId!, this.product.id!, data.selectedTransition?.trigger, data.comments)
          .then(x => {
            if (x) {
              var stateHasChanged = this.product.currentWorkflowState?.state !== x?.state;

              this.product.currentWorkflowState = x;

              if (stateHasChanged) {
                this.showMessage(`Workflow successfully transitioned to ${x.name}!`);
              } else {
                this.showMessage(`Comment successfully added!`);
              }
            } else {
              this.showMessage("Failed to update workflow!");
            }
          })
          .catch((err: any) => {
            this.showMessage("Failed to update workflow!");
          });

      })
    );
  }

  canAccessCurrentWorkflowState() {
    if (this.isSituUser) {
      return true; // Situ admin etc can always access this
    }

    if (this.isExternalProductContractorUser) {
      return true; // This user can always access this
    }

    if (this.isAuthorizedForProductsCompany &&
      (this.isCompanyProductPublisherUser)
    ) {
      return true; // These users can access this if the product is from a company they are authorised to access
    }

    return false;
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }
}